import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './Item.style';
import Checkbox from '../../ui/Checkbox/Checkbox';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import constants from '../../../config/constants';

const Item = ({ item, onItemChange, index, appCtx }) => {
  const isTocom = appCtx.store === constants.STORES.to_com;
  const [checked, setChecked] = useState(item.checked);
  const handleChange = ({ isSelected }) => {
    setChecked(isSelected);
    if (onItemChange) onItemChange(item, isSelected);
  };
  return (
    <div className="item-container">
      <Checkbox
        variant="secondary"
        isChecked={checked}
        id={`Ln${index + 1}`}
        type={`mkp-succes ${isTocom ? 'tocom' : ''}`}
        selectedBorderClass=" mkp-border"
        normalBorderClass=" mkp-normal-border"
        onChange={handleChange}
      >
        {item.tagName}
      </Checkbox>
      <style jsx>{styles}</style>
    </div>
  );
};

Item.propTypes = {
  item: PropTypes.object.isRequired,
  onItemChange: PropTypes.func,
  index: PropTypes.number.isRequired,
  appCtx: PropTypes.object.isRequired,
};

Item.defaultProps = {
  onItemChange: undefined,
};

export default withApplicationContext(Item);
